export { MemoizedIconBanner as IconBanner } from "./IconBanner_wAddOnChnls";
export type { IconBannerProps } from "./IconBanner_wAddOnChnls";
